import { API_BASE, getToken } from '../../services/apiClient';

// Cutting a Fieldwire plan sheet into pieces the reader can see at full detail (it
// downsizes anything wider than ~1500 px, and a loop symbol on a whole traffic sheet
// is a few pixels). Shared by the sheet viewer's Suggest tasks and the item layout.
export const AI_TILE = 1400;
export const AI_OVERLAP = 120;
export const AI_MERGE_PX = 40;

export function tilesFor(w, h) {
  const step = AI_TILE - AI_OVERLAP;
  const starts = n => { const out = []; for (let s = 0; ; s += step) { const v = Math.max(0, Math.min(s, n - AI_TILE)); if (!out.includes(v)) out.push(v); if (s + AI_TILE >= n) break; } return out; };
  const out = [];
  for (const y of starts(h)) for (const x of starts(w)) out.push({ x, y, w: Math.min(AI_TILE, w - x), h: Math.min(AI_TILE, h - y) });
  return out;
}
export function mergeProposals(items) {
  const kept = [];
  for (const it of [...items].sort((a, b) => b.confidence - a.confidence)) {
    if (kept.some(k => Math.hypot(k.x - it.x, k.y - it.y) < AI_MERGE_PX)) continue;
    kept.push(it);
  }
  return kept.sort((a, b) => (a.y - b.y) || (a.x - b.x));
}
// The sheet image through the app (Fieldwire's file host has no CORS headers, so a
// plain <img> could not be drawn to a canvas).
export async function loadSheetBitmap(projectId, floorplanId) {
  const r = await fetch(`${API_BASE}/projects/${projectId}/fieldwire/sheets/${floorplanId}/image`, { headers: { 'x-worker-token': getToken() } });
  if (!r.ok) throw new Error('The sheet image would not load.');
  return createImageBitmap(await r.blob());
}
export async function tileBlob(bmp, t) {
  const c = document.createElement('canvas'); c.width = t.w; c.height = t.h;
  c.getContext('2d').drawImage(bmp, t.x, t.y, t.w, t.h, 0, 0, t.w, t.h);
  const blob = await new Promise(res => c.toBlob(res, 'image/jpeg', 0.85));
  if (!blob) throw new Error('Could not cut the sheet into tiles.');
  return blob;
}
// A square crop around a point (image pixels) — a hand-placed example for the reader.
export async function cropBlob(bmp, cx, cy, size = 240) {
  const half = size / 2;
  const x = Math.max(0, Math.min(bmp.width - size, Math.round(cx - half)));
  const y = Math.max(0, Math.min(bmp.height - size, Math.round(cy - half)));
  const w = Math.min(size, bmp.width), h = Math.min(size, bmp.height);
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  c.getContext('2d').drawImage(bmp, x, y, w, h, 0, 0, w, h);
  const blob = await new Promise(res => c.toBlob(res, 'image/jpeg', 0.9));
  if (!blob) throw new Error('Could not cut the example.');
  return blob;
}
